import trade from './trade';

export default [
	{
		path: '/app/portfolio/:portfolio/approvals',
		name: 'portfolio.approvals',
		component: () => import('../../../../../components/dashboard/client/portfolio/PortfolioApprovalsComponent.vue'),
		meta: {
			allowedUsers: ['client']
		}
	},
	{
		path: '/app/portfolio/:portfolio',
		name: 'portfolio.details',
		component: () => import('../../../../../components/dashboard/client/portfolio/PortfolioDetailsComponent.vue'),
		meta: {
			allowedUsers: ['client']
		}
	},
	{
		path: ':portfolio/fund-iclf',
		name: 'portfolio.fund-iclf',
		component: () => import('../../../../../components/dashboard/client/portfolio/IclfFundingComponent.vue'),
		meta: {
			allowedUsers: ['client']
		}
	},
	...trade
];
